export const TOKEN_API_URL = 'csrf_token';

export const TOKENS_QUERY_KEY = 'tokens';
